export default __webpack_public_path__ + "static/media/flag_united-kingdom.690315a2.svg";